/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Summary_Project_TitleInputs */

const en_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project`)
};

const fr_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projet`)
};

const de_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt`)
};

const it_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progetto`)
};

const ru_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проект`)
};

const es_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto`)
};

const zh_cn2_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目`)
};

const ja_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクト`)
};

const hi_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना`)
};

const pt_pt2_new_project_summary_project_title = /** @type {(inputs: New_Project_Summary_Project_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto`)
};

/**
* | output |
* | --- |
* | "Project" |
*
* @param {New_Project_Summary_Project_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_summary_project_title = /** @type {((inputs?: New_Project_Summary_Project_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Summary_Project_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_summary_project_title(inputs)
	if (locale === "de") return de_new_project_summary_project_title(inputs)
	if (locale === "it") return it_new_project_summary_project_title(inputs)
	if (locale === "ru") return ru_new_project_summary_project_title(inputs)
	if (locale === "es") return es_new_project_summary_project_title(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_summary_project_title(inputs)
	if (locale === "ja") return ja_new_project_summary_project_title(inputs)
	if (locale === "hi") return hi_new_project_summary_project_title(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_summary_project_title(inputs)
	return en_new_project_summary_project_title(inputs)
});